/**
 * Canonical normalization used for client-side duplicate-attendee detection.
 * Lowercase + trim only — DO NOT use for validation or backend equality.
 */
export function normalizeEmail(email: string): string {
  return email.toLowerCase().trim();
}
